import type { ICountryDefinition } from "@/countries/country-common";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";
import { ECountry, ECountryCode, ELanguageCode } from "@/domains/country/country.types.ts";

export const FRANCE_DATABASE_COUNTRY_ID = 1;

export const FranceCountryDefinition = {
  addressProvider: EAddressProvider.FRENCH_GOVERNMENT,
  countryCode: ECountryCode.FRANCE,
  languageCode: ELanguageCode.FRENCH,
  country: ECountry.FRANCE,
  phoneAllowed: true,
  addressAllowed: true,
  phone: {
    mask: "+33 99 99 99 99 99",
    placeholder: "+33 99 99 99 99 99", // 10 chiffres
    prefix: "+33",
  },
  databaseCountryId: FRANCE_DATABASE_COUNTRY_ID,
} as const satisfies ICountryDefinition;
